import { SMILE_VIDEO_FILE_TYPE } from "../../../types/smileDesign/historyItem";
import { uploadFileToBox } from "./UploadFiles";

export function smileVideoFileName(patientName: string): string {
    const safe = (patientName || "patient").replace(/[^\w\-]+/g, "_").slice(0, 40);
    return `${safe}-smile-video.mp4`;
}

export async function uploadSmileVideoToCase({
    videoUrl,
    patientName,
    caseBoxId,
    accessToken,
}: {
    videoUrl: string;
    patientName: string;
    caseBoxId: number | string;
    accessToken: string;
}): Promise<{ box_id: string; name: string; type: string }> {
    const response = await fetch(videoUrl);
    if (!response.ok) {
        throw new Error("Failed to read the generated video");
    }

    const blob = await response.blob();
    if (!blob.size) {
        throw new Error("Generated video is empty");
    }

    const file = new File([blob], smileVideoFileName(patientName), {
        type: blob.type || "video/mp4",
    });

    const uploaded = await uploadFileToBox(file, caseBoxId, accessToken);

    return {
        box_id: String(uploaded.id),
        name: uploaded.name || file.name,
        type: SMILE_VIDEO_FILE_TYPE,
    };
}
